import React from 'react'
import { Spinner } from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../css/generals/loading.css'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function Loading (props) {
  const { t } = useTranslation('loading')
  return (
        <div className="bodyLoading">
            <h4>{t('cargando')}</h4>
            <Spinner color={props.color} />
        </div>
  )
}

Loading.propTypes = {
  color: PropTypes.string
}
